import React from 'react';
import Dropzone from 'react-dropzone';
import { PlusIcon } from '@fronton/icons-react';
import { FileUploadDropzoneProps } from '../types';
import { inputContainer } from './dropzone-no-caption.styles';
import { dropzoneNoLabel } from './dropzone-common.styles';

export const DropzoneNoCaption: React.FC<FileUploadDropzoneProps> = ({
  inputProps,
  onFilesSelect,
  ...htmlProps
}) => {
  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      onFilesSelect?.(acceptedFiles);
    },
    [onFilesSelect],
  );

  return (
    <div {...htmlProps}>
      <Dropzone onDrop={onDrop}>
        {({ getInputProps, getRootProps }) => (
          <div
            {...getRootProps({
              className: dropzoneNoLabel,
              // eslint-disable-next-line i18next/no-literal-string
              'data-anchor': 'dropzone',
            })}
          >
            <PlusIcon type="outline" size="l" color="text-primary" />
            <div className={inputContainer}>
              <input {...getInputProps(inputProps)} />
            </div>
          </div>
        )}
      </Dropzone>
    </div>
  );
};
